const LifeCoverEdit = [
  { label: "1000000", value: "1000000" },
  { label: "1500000", value: "1500000" },
  { label: "2000000", value: "2000000" },
  { label: "2500000", value: "2500000" },
  { label: "3000000", value: "3000000" },
  { label: "3500000", value: "3500000" },
  { label: "4000000", value: "4000000" },
  { label: "4500000", value: "4500000" },
  { label: "5000000", value: "5000000" },
  { label: "5500000", value: "5500000" },
  { label: "6000000", value: "6000000" },
  { label: "6500000", value: "6500000" },
  { label: "7000000", value: "7000000" },
  { label: "7500000", value: "7500000" },
  { label: "8000000", value: "8000000" },
  { label: "8500000", value: "8500000" },
  { label: "9000000", value: "9000000" },
  { label: "9500000", value: "9500000" },
  { label: "1 Crore", value: "10000000" },
  { label: "1.5 Crore", value: "15000000" },
  { label: "2 Crore", value: "20000000" },
  { label: "2.5 Crore", value: "25000000" },
  { label: "3 Crore", value: "30000000" },
  { label: "3.5 Crore", value: "35000000" },
  { label: "4 Crore", value: "40000000" },
  { label: "4.5 Crore", value: "45000000" },
];

export default LifeCoverEdit;
